import { SettingOutlined } from "@ant-design/icons";
import { Button, Col, Divider, Row, Space } from "antd";
import { useCallback, useEffect, useState } from "react";
import { createUseStyles } from "react-jss";
import { useLocation, useNavigate } from "react-router-dom";
import { _STYLES } from "../../common/utils/customStyles";
import { ROUTES } from "../navigation";
import UserMenu from "../userMenu/userMenu";
import headerMenuStyles from "./headerMenuStyles";
import Notifications from "../../notifications/notifications.container";
import usePermission from "../../permissions/hooks/usePermission";
import {
  MODULES,
  PERMISSION_FEATURES,
} from "../../permissions/types/permission-types";

const { textSm3, textMd1, w100, colorText, textSm2, textMd2 } = _STYLES;
const { userMenuWrap, userBtn } = headerMenuStyles;
const useStyles = createUseStyles({
  textSm3,
  textMd1,
  w100,
  userMenuWrap,
  colorText,
  userBtn,
  textSm2,
  textMd2,
});

const HeaderMenu = () => {
  const classes = useStyles();

  const [headerText, setHeaderText] = useState("");

  const navigate = useNavigate();

  const { pathname } = useLocation();

  const isAuthorizedToManage = usePermission(
    MODULES.SETTINGS,
    PERMISSION_FEATURES.ENABLE,
  );

  const generateHeaderTextForPage = useCallback(() => {
    const splittedPath = pathname.split("/");

    if (splittedPath.length >= 3) {
      const midPath = splittedPath.at(1);

      return {
        [ROUTES.appointments]: "Appointment Details",
      }[midPath];
    }

    const formattedPath = splittedPath.at(-1);

    return {
      [ROUTES.dashboard]: "Dashboard",
      [ROUTES.appointments]: "Appointments",
      [ROUTES.appointmentDetails]: "Appointment Details",
      [ROUTES.billings]: "Billings",
      [ROUTES.guardians]: "Guardians",
      [ROUTES.patients]: "Patients",
      [ROUTES.settings]: "Settings",
      [ROUTES.inventory]: "Inventory",
      [ROUTES.suppliers]: "Suppliers",
      [ROUTES.schedule]: "Today's Schedule",
      [ROUTES.smsMessages]: "SMS Messages",
      [ROUTES.logs]: "Logs",
    }[formattedPath];
  }, [pathname]);

  const navigateToSettings = useCallback(() => {
    navigate(ROUTES.settings);
  }, [navigate]);

  useEffect(() => {
    setHeaderText(generateHeaderTextForPage());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  return (
    <Row
      justify={"space-between"}
      align={"middle"}
      className={classes.userMenuWrap}
    >
      <Col>
        <h1
          className={
            classes.textMd2 + " " + classes.colorText + " " + classes.fontBold
          }
        >
          {headerText}
        </h1>
      </Col>
      <Col>
        <Space>
          <Space size={12}>
            <Notifications />
            {isAuthorizedToManage && (
              <Button onClick={navigateToSettings} icon={<SettingOutlined />} />
            )}
          </Space>
          <Divider type="vertical" className={classes.h100} />
          <UserMenu />
        </Space>
      </Col>
    </Row>
  );
};

export default HeaderMenu;
